import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';
import { useTranslation } from 'next-i18next';
import Swiper from '~/ui/components/common/Swiper/Swiper';
import { bathImages } from '../../../../assets/mocks/swiperImages';

const BathSection = () => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$bath' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$bath' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });

  const translatedBathImages = bathImages.map(image => ({
    ...image,
    title: t(`${image.url_key}Title`),
    alt: t(`${image.url_key}Alt`),
    url_key: tLink(image.url_key),
  }));

  return (
    <div className="bath-section">
      <div className="column-container bath-container">
        <div className="stacked-text-container home-title-dark bath-text bath-left">
          <Link href={tLink('bath')} className="bath-link">
            <p className="stacked-text">{t('text')}</p>
            <button type="button" className="btn-plain-inverted stacked-btn">
              {t('btn')}
            </button>
          </Link>
        </div>
        <div className="bath-img bath-right bath-hide-mobile">
          <Link href={tLink('towels')} className="bath-link">
            <img
              src="/images/homePage/the-westin-heavenly-towel-collection.webp"
              alt={`${tButton('shopNow')}: ${t('towelsAlt')}`}
              width={904}
              height={533}
              loading="lazy"
              decoding="async"
              fetchPriority="low"
            />
            <h3 className="bath-title">{t('towelsTitle')}</h3>
          </Link>
        </div>
        <div className="bath-left bath-fixed-height">
          <img
            className="bath-hide-mobile"
            src="/images/homePage/westin-bath-lifestyle.webp"
            alt={t('bathLifestyle')}
            width={904}
            height={950}
            loading="lazy"
            decoding="async"
            fetchPriority="low"
          />
          <img
            className="bath-hide-desktop"
            src="/images/homePage/westin-bath-lifestyle-mob.webp"
            alt={t('robesTitle')}
            width={1300}
            height={848}
            loading="lazy"
            decoding="async"
            fetchPriority="low"
          />
        </div>
        <div className="bath-right bath-hide-mobile">
          <Link href={tLink('robes')} className="bath-link">
            <img
              src="/images/homePage/the-westin-heavenly-robe-collection.webp"
              alt={`${tButton('shopNow')}: ${t('robesAlt')}`}
              width={904}
              height={533}
              loading="lazy"
              decoding="async"
              fetchPriority="low"
            />
            <h3 className="bath-title">{t('robesTitle')}</h3>
          </Link>
        </div>
      </div>
      <div className="bath-hide-desktop bath-mobile-swiper">
        <Swiper slides={translatedBathImages} />
      </div>
    </div>
  );
};

export default BathSection;
